import Vue from 'vue'
import AWS from 'aws-sdk'
AWS.config.region = 'ap-southeast-1'

AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: 'ap-southeast-1:59558f85-92f5-4e00-a7c8-de6e92919564'  // Replace with your Identity Pool ID
});
Vue.prototype.$listObjects = function(bucket) {
    const s3 = new AWS.S3();
          var params = { 
            Bucket: bucket +'/account_id/',
           };
            s3.listObjects(params, function (err, data) {
              if (err) {
                console.log("Error", err);
              } else if (data) {
                console.log("Success", data);
              }
            });
}

Vue.prototype.$uploadToS3 = function(params, callback) {
    // Initialize S3
    const s3 = new AWS.S3();
    var files = params.files
   var locations = []
   var _index = 1
   for (const file of files) {
   //  _index = files[_index];
    var s3params = {
        Bucket: params.storage, // Replace with your bucket name
        Key: params.account +'/'+ params.date+'/'+file.name,      // File name (can also specify a path like 'uploads/filename')
        Body: file,          // File object
        ContentType: file.type
      };
       // Upload the file
    s3.upload(s3params).on('httpUploadProgress', function(evt) {
        console.log('Progress:', Math.round((evt.loaded / evt.total) * 100) + '%');
        callback({status: 'Progress', progress:Math.round((evt.loaded / evt.total) * 100),count: _index+'/'+files.length })
    }).send(function(err, data) {
        if (err) {
            console.log('Error uploading file:', err);
            callback({status: 'Failed', error:err })
        } else {
          
           locations.push(data.Location)
            if(_index==files.length){
                callback({status: 'Complete', progress:100, count: _index+'/'+files.length, locations:locations})
            } else {
                console.log('File uploaded successfully at:', data.Location);
                callback({status: 'File Complete', progress:100, count: _index+'/'+files.length})
                _index++
            }
        }
    });
  }
   
  }
// AWS.config.credentials.get(function(err) {
//   if (err) {
//       console.log("Error: ", err);
//   } else {
//       console.log("Cognito Identity ID: " + AWS.config.credentials.identityId);
//   }
// });
//Vue.use(AWS)
//var AWS = require('aws-sdk');
 //import AWS from 'aws-sdk'
// // AWS.config.update({
// //   accessKeyId: "YOURKEY",
// //   secretAccessKey: "YOURSECRET"
// // });
// AWS.config.region = 'ap-southeast-1'

// AWS.config.credentials = new AWS.CognitoIdentityCredentials({
//   IdentityPoolId: 'ap-southeast-1:59558f85-92f5-4e00-a7c8-de6e92919564'  // Replace with your Identity Pool ID
// });

// AWS.config.credentials.get(function(err) {
//   if (err) {
//       console.log("Error: ", err);
//   } else {
//       console.log("Cognito Identity ID: " + AWS.config.credentials.identityId);
//   }
// });


// const s3 = new AWS.S3();

// // Set the parameters for S3.getBucketCors
// var params = { 
//   Bucket: "zerasuite",

//  };

// // call S3 to retrieve CORS configuration for selected bucket
// //listing
// s3.listObjects(params, function (err, data) {
//   if (err) {
//     console.log("Error", err);
//   } else if (data) {
//     console.log("Success", data);
//   }
// });
// s3.getSignedUrl('getObject', params, (err, url) => {
//   if (err) {
//     console.log('Error generating URL', err);
//   } else {
//     console.log('Image URL:', url);
  
//   }
// });